/* eslint-disable */
export default {
  recentActivities: 'Activités récentes',
  text: 'Texto',
  fax: 'Télécopieur',
  voicemail: 'Messagerie vocale',
  call: 'Appeler',
} as const;

// @key: @#@"recentActivities"@#@ @source: @#@"Recent Activities"@#@
// @key: @#@"text"@#@ @source: @#@"Text"@#@
// @key: @#@"fax"@#@ @source: @#@"Fax"@#@
// @key: @#@"voicemail"@#@ @source: @#@"Voicemail"@#@
// @key: @#@"call"@#@ @source: @#@"Call"@#@
